// extracted by mini-css-extract-plugin
export default {"root":"GoToCommentLink-root-49c2b4c6c8af346ce7814325e2fc938f","arrow":"GoToCommentLink-arrow-69a59856e4cdd37f5cd8b9ed372eded3"};